import { useRef } from "react";
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";

export const Tilt = ({ children, className = "", max = 6 }) => {
    const ref = useRef(null);
    const x = useMotionValue(0.5);
    const y = useMotionValue(0.5);
    const rx = useSpring(useTransform(y, [0, 1], [max, -max]), { stiffness: 140, damping: 16 });
    const ry = useSpring(useTransform(x, [0, 1], [-max, max]), { stiffness: 140, damping: 16 });

    const onMove = (e) => {
        const rect = ref.current.getBoundingClientRect();
        x.set((e.clientX - rect.left) / rect.width);
        y.set((e.clientY - rect.top) / rect.height);
    };
    const reset = () => {
        x.set(0.5);
        y.set(0.5);
    };

    return (
        <motion.div
            ref={ref}
            onMouseMove={onMove}
            onMouseLeave={reset}
            style={{ rotateX: rx, rotateY: ry, transformStyle: "preserve-3d", perspective: 900 }}
            className={className}
        >
            {children}
        </motion.div>
    );
};
